<div class="scrollContainer">
    @if (showLeftScrollButton()) {
        <div class="buttonContainer">
            <button type="button" class="button primary" (click)="scrollLeft()">
                <i class="fas fa-chevron-left"></i>
            </button>
        </div>
    }
    <div #scrollContainer class="scrollContent" (scroll)="computeButtonVisibilityDebounced()">
        <header class="tabHeader" #tabHeader>
            <div class="tabOverflowContainer">
                <div class="tabContainer">
                    <ng-content />
                </div>
            </div>
        </header>
    </div>
    @if (showRightScrollButton()) {
        <div class="buttonContainer">
            <button type="button" class="button primary" (click)="scrollRight()">
                <i class="fas fa-chevron-right"></i>
            </button>
        </div>
    }
</div>
